import React from "react";
import AllRecipes from "../Components/AllRecipes";

export default function ShowAllRecipes({ recipes }) {
  return <AllRecipes recipes={recipes} />;
}
